import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../utils/classNames';
import ServiceIcon from '../ServiceIcon';
/**
 * Renders any of a variety of views associated with the "price" region of a product tile.
 *
 * The component name is for convenience and should not be taken too literally.
 * Some of these views identify literal, numeric pricing information, while
 * others include just a text description that is more-or-less related to pricing.
 *
 * For visual examples, see "Price" within Storybook or see the legacy ProductTile
 * design at https://atlas.np.tools.playstation.net/design/f641f67c-066b-4a6d-9eac-0cdb5198d5bb/45?bounds=0.314,2.091,0.477,0.354&rev=45&x=1314.70&y=6433.77
 */

var Price = function Price(props) {
  var className = props.className,
      qa = props.qa,
      base = props.base,
      discount = props.discount,
      format = props.format,
      isExclusive = props.isExclusive,
      isFree = props.isFree,
      isTiedToSubscription = props.isTiedToSubscription,
      serviceType = props.serviceType,
      text = props.text,
      disabled = props.disabled;
  if (!base && !discount && !text) return null;

  var _Price$getClassName = Price.getClassName({
    className: className,
    serviceType: serviceType,
    disabled: disabled
  }),
      rootClass = _Price$getClassName.root,
      serviceIconClass = _Price$getClassName.serviceIcon,
      priceTextClass = _Price$getClassName.priceText,
      strikeThroughPriceTextClass = _Price$getClassName.strikeThroughPriceText,
      priceAndStrikeThroughLineClass = _Price$getClassName.priceAndStrikeThroughLine;

  var isIncluded = isFree && isTiedToSubscription;
  var isDiscounted = discount && discount !== base;
  var displayStrikethrough = isDiscounted && !isIncluded;
  var finalPrice = base;
  var originalPrice = null;

  if (isDiscounted) {
    finalPrice = discount;
    originalPrice = /[0-9]/.test(finalPrice) || isFree || isExclusive ? base : null;
  }

  return /*#__PURE__*/React.createElement("div", {
    "data-qa": qa,
    className: rootClass
  }, serviceType && serviceType !== 'NONE' && /*#__PURE__*/React.createElement(ServiceIcon, {
    qa: "".concat(qa, "#service-icon"),
    className: serviceIconClass,
    serviceType: serviceType,
    size: "2"
  }), finalPrice ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: priceAndStrikeThroughLineClass
  }, /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#display-price"),
    "aria-hidden": isDiscounted ? 'true' : 'false',
    className: priceTextClass
  }, finalPrice), displayStrikethrough && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, format('string', 'msgid_sr_price_original_strike', finalPrice, originalPrice)), /*#__PURE__*/React.createElement("s", {
    "data-qa": "".concat(qa, "#price-strikethrough"),
    "aria-hidden": "true",
    className: strikeThroughPriceTextClass
  }, originalPrice)))) : /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#price-text"),
    className: priceTextClass
  }, text));
};

Price.getClassName = function (_ref) {
  var className = _ref.className,
      serviceType = _ref.serviceType,
      disabled = _ref.disabled;
  return {
    root: classNames(className, 'psw-price', 'psw-l-inline', 'psw-l-line-left-top'),
    serviceIcon: 'psw-m-r-2',
    conceptPriceRange: "psw-c-t-".concat(disabled ? 'disabled' : '2'),
    priceAndStrikeThroughLine: classNames('psw-l-line-left-top', 'psw-l-line-wrap', 'psw-clip', 'psw-t-h-body-1', 'psw-l-anchor', 'psw-l-line-no-wrap'),
    priceText: classNames('psw-m-r-3', {
      'psw-c-t-ps-plus': !disabled && serviceType === 'PS_PLUS'
    }, {
      'psw-c-t-disabled': disabled
    }),
    strikeThroughPriceText: "psw-c-t-".concat(disabled ? 'disabled' : '2')
  };
};

Price.defaultProps = {
  className: '',
  qa: '',
  base: '',
  discount: '',
  isExclusive: false,
  isFree: false,
  isTiedToSubscription: false,
  serviceType: 'NONE',
  text: '',
  disabled: false
};
Price.propTypes = {
  className: PropTypes.string,
  qa: PropTypes.string,
  base: PropTypes.string,
  discount: PropTypes.string,
  format: PropTypes.func.isRequired,
  isExclusive: PropTypes.bool,
  isFree: PropTypes.bool,
  isTiedToSubscription: PropTypes.bool,
  serviceType: PropTypes.string,
  text: PropTypes.string,
  disabled: PropTypes.bool
};
export default Price;